import React,{useState,useEffect} from 'react'
import { ListItemButton,Stack,ListItem,IconButton, Avatar,Typography,ListItemAvatar,ListItemText,Divider, Button } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import clinicService from '../../../../../services/clinic.service';
import {toast} from 'react-toastify'

function MediaListItem({item,updateMediaList}) {
  const [select,setSelect] = useState(false)

  const handleDelete = ()=>{
    const itemArray = [item.id]
    clinicService.deleteMedia(item.clinicId,itemArray)
    .then(res=>{
        toast.success("Media Deleted",{
          position: toast.POSITION.BOTTOM_RIGHT
        })
        updateMediaList()
    })
    .catch(error=>{
      console.log(error)
        toast.error("Error while Delete",{
          position: toast.POSITION.BOTTOM_RIGHT
        })
    })
  }
  const handleCopy = async (textToCopy)=>{
   
    try {
      await navigator.clipboard.writeText(textToCopy);
      toast.success("Copied",{
        position:toast.POSITION.BOTTOM_RIGHT
    })
    } catch (error) {
      console.error('Failed to copy using navigator.clipboard:', error);
      // Fallback: use textarea and document.execCommand('copy')
      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      toast.success("Copied",{
        position:toast.POSITION.BOTTOM_RIGHT
    })
    }
   
  }
  return (
    <>
     <ListItem alignItems="flex-start"
      secondaryAction={
        <IconButton edge="end" aria-label="delete" onClick = {()=>setSelect(!select)} >
          <DeleteIcon />
        </IconButton>
      }
     >
        <ListItemAvatar sx={{marginRight:2}}>
          <img src={item.thumbnailPath} loading='lazy'/>
        </ListItemAvatar>
        <ListItemText
          primary={item.name}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {item.createdAt}
              </Typography>
              {" — "+item.type}
              <Typography>
                {item.size}
                </Typography> 
                <IconButton onClick={()=>handleCopy(item.path)}>
                    <ContentCopyIcon/>
                </IconButton>
            </React.Fragment>
          }
        />
      </ListItem>
      {select?<>
      <div style={{margin:"5px",padding:10,backgroundColor:'InfoBackground',borderRadius:'10px'}}> 
           <Stack direction="row" spacing={2} alignItems="center">
            
          
            <Typography>Sure Delete ? </Typography> 
            <Button variant='contained' color='warning'  onClick={handleDelete}>Yes</Button> 
            <Button variant='outlined' onClick={()=>setSelect(!select)}>No</Button>
            </Stack>
     </div>
       
      </>:""}
      <Divider variant="inset" component="li" />
      </>
  )
}

export default MediaListItem